import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

type Params = {
	uid: string;
	profilePictureDataURI: string;
};
export const saveProfilePicture = makeSubmitData<Params>("saveProfilePicture");
